import type { ApiResponseInterface } from "@ts/interfaces/ApiResponseInterface";
import { post } from "./httpClient";
import type { UpdatePasswordApiRequestInterface } from "@ts/interfaces/student/api/updatePasswordApiInterface";

export const getOTP = async (): Promise<ApiResponseInterface<void>> => {
  return await post<ApiResponseInterface<void>>("/user/generate-otp", {
    otp_type: "change_password"
  });
};

export const validateOTP = async (
  otp: string
): Promise<ApiResponseInterface<void>> => {
  return await post("/user/validate-otp", {
    otp_type: "change_password",
    otp
  });
};

export const updatePassword = (
  payload: UpdatePasswordApiRequestInterface
): Promise<ApiResponseInterface<void>> => {
  return post("/user/change-password", {
    ...payload
  });
};

export const changePasswordApi = {
  getOTP,
  validateOTP,
  updatePassword
};
